// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ——— Medical machine profile (Stitch: Medical machine — Ultrasound Unit A) ——— */
.machine-profile {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  padding: 24px;
  background: #ffffff;
  min-height: 100%;
}

.machine-profile__inner {
  box-sizing: border-box;
  width: 100%;
  max-width: none;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-width: 0;
}

/* Loader wraps page sections in a bare div — carry the stack gap through it */
.machine-profile__stack,
.machine-profile__inner > div {
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-width: 0;
  width: 100%;
}

[dir='rtl'] .machine-profile__back .lucide,
[dir='rtl'] .machine-profile__view-link .lucide,
[dir='rtl'] .machine-profile__catalog-link .lucide {
  transform: scaleX(-1);
}

/* ——— Hero ——— */
.machine-profile__hero {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: space-between;
  gap: 16px;
  margin: 0;
  padding: 0;
}

@media (min-width: 900px) {
  .machine-profile__hero {
    flex-direction: row;
    align-items: center;
  }
}

.machine-profile__hero-left {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  min-width: 0;
}

.machine-profile__back {
  box-sizing: border-box;
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 8px;
  background: #ffffff;
  color: #64748B;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
  margin-top: 2px;
}

.machine-profile__back:hover {
  background: #F1F5F9;
  color: #0EA5E9;
}

.machine-profile__hero-text {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.machine-profile__title-row {
  display: flex;
  align-items: baseline;
  gap: 10px;
  flex-wrap: wrap;
}

.machine-profile__title-row h1 {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -0.025em;
  line-height: 1.15;
  color: #0F172A;
}

.machine-profile__status-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  padding-inline-start: 2px;
}

.machine-profile__chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
}

.machine-profile__chip--code {
  background: #F1F5F9;
  color: #64748B;
  border-radius: 6px;
  font-weight: 500;
  font-size: 12px;
  padding: 2px 8px;
  align-self: center;
}

.machine-profile__chip--ok {
  background: #ffffff;
  color: #0F766E;
  border: 1px solid #E2E8F0;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.machine-profile__chip--ok .machine-profile__chip-dot {
  background: #14B8A6;
  width: 8px;
  height: 8px;
}

.machine-profile__chip--cal {
  background: #F1F5F9;
  color: #475569;
  font-weight: 500;
}

.machine-profile__chip--cal .lucide {
  color: #0EA5E9;
}

.machine-profile__chip--sky {
  background: #E0F2FE;
  color: #0284C7;
}

.machine-profile__chip--muted {
  background: #F1F5F9;
  color: #64748B;
}

.machine-profile__chip-dot {
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  background: currentColor;
  flex-shrink: 0;
}

.machine-profile__chip-dot.is-teal {
  background: #14B8A6;
}

.machine-profile__hero-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  flex-shrink: 0;
}

.machine-profile__btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.machine-profile__btn--primary {
  border: none;
  background: #0EA5E9;
  color: #ffffff;
  font-weight: 600;
}

.machine-profile__btn--primary:hover {
  background: #0284C7;
}

.machine-profile__btn--ghost {
  border: none;
  background: #ffffff;
  color: #475569;
}

.machine-profile__btn--ghost:hover {
  background: #F1F5F9;
  color: #0F172A;
}

.machine-profile__btn--icon {
  width: 36px;
  padding: 0;
  border: none;
  background: #ffffff;
  color: #64748B;
}

.machine-profile__btn--icon:hover {
  background: #F1F5F9;
  color: #0F172A;
}

/* ——— Top cards ——— */
.machine-profile__top {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  min-width: 0;
  align-items: stretch;
}

@media (min-width: 960px) {
  .machine-profile__top {
    grid-template-columns: minmax(0, 7fr) minmax(0, 5fr);
  }
}

.machine-profile__card {
  box-sizing: border-box;
  background: #ffffff;
  border: none;
  border-radius: 12px;
  padding: 20px;
  min-width: 0;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
  display: flex;
  flex-direction: column;
}

.machine-profile__card--packages {
  padding: 24px;
}

.machine-profile__card--location {
  justify-content: flex-start;
}

.machine-profile__clinic-list {
  list-style: none;
  margin: 14px 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.machine-profile__clinic-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 8px;
  background: #F8FAFC;
}

.machine-profile__clinic-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 6px;
  background: #E0F2FE;
  color: #0284C7;
  flex-shrink: 0;
}

.machine-profile__clinic-body {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.machine-profile__clinic-name {
  font-size: 13px;
  font-weight: 600;
  color: #0F172A;
}

.machine-profile__clinic-meta {
  font-size: 11px;
  color: #64748B;
}

.machine-profile__empty-note {
  margin: 14px 0 0;
  font-size: 13px;
  color: #94A3B8;
}

.machine-profile__card-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 14px;
  margin: 0;
  border-bottom: 1px solid #F1F5F9;
}

.machine-profile__card-head--packages {
  align-items: center;
  flex-wrap: wrap;
  padding-bottom: 16px;
  margin-bottom: 0;
}

.machine-profile__card-title {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  min-width: 0;
}

.machine-profile__card-title h2 {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #0F172A;
  line-height: 1.25;
}

.machine-profile__card-title p {
  margin: 2px 0 0;
  font-size: 12px;
  color: #64748B;
  line-height: 1.35;
}

.machine-profile__card-icon {
  box-sizing: border-box;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #F1F5F9;
  color: #0EA5E9;
}

.machine-profile__id-badge {
  flex-shrink: 0;
  padding: 4px 10px;
  border-radius: 8px;
  background: #F1F5F9;
  font-size: 12px;
  font-weight: 500;
  color: #64748B;
}

.is-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-variant-numeric: tabular-nums;
}

.is-strong {
  font-weight: 600;
  color: #0F172A;
}

.is-muted {
  color: #64748B !important;
}

.is-soft {
  font-weight: 400;
  color: #94A3B8;
  font-size: 12px;
}

.is-ok {
  color: #14B8A6 !important;
}

.machine-profile__spec-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 12px;
  row-gap: 16px;
  margin: 0;
  padding: 16px 0 0;
}

.machine-profile__spec-grid--supported {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

@media (min-width: 640px) {
  .machine-profile__spec-grid,
  .machine-profile__spec-grid--supported {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

.machine-profile__spec-grid dt {
  margin: 0;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #94A3B8;
  line-height: 1.2;
}

.machine-profile__spec-grid dd {
  margin: 2px 0 0;
  font-size: 13px;
  font-weight: 500;
  color: #0F172A;
  line-height: 1.35;
  word-break: break-word;
}

.machine-profile__with-icon {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.machine-profile__with-icon.is-end {
  justify-content: flex-end;
  width: 100%;
}

.machine-profile__with-icon .lucide {
  color: #94A3B8;
  flex-shrink: 0;
}

.machine-profile__probe-banner {
  margin-top: auto;
  padding: 12px;
  border-radius: 8px;
  background: #F1F5F9;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
  font-size: 12px;
  color: #64748B;
  line-height: 1.35;
}

.machine-profile__probe-copy {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.machine-profile__probe-copy .lucide {
  color: #0EA5E9;
  flex-shrink: 0;
}

.machine-profile__probe-copy strong {
  color: #0F172A;
  font-weight: 600;
}

.machine-profile__verified {
  flex-shrink: 0;
  padding: 2px 8px;
  border-radius: 4px;
  background: #ffffff;
  color: #14B8A6;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
}

/* ——— Location ——— */
.machine-profile__location-body {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 12px 0;
  margin: 0;
}

.machine-profile__kv-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.machine-profile__kv-row > div {
  min-width: 0;
  flex: 1 1 0;
}

.machine-profile__kv-row .is-end {
  text-align: end;
}

.machine-profile__kv-label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #94A3B8;
  line-height: 1.2;
}

.machine-profile__kv-value {
  margin: 2px 0 0;
  font-size: 13px;
  color: #0F172A;
  line-height: 1.35;
}

.machine-profile__kv-value.is-link {
  color: #0EA5E9;
  font-weight: 600;
}

.machine-profile__tech-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 6px;
}

.machine-profile__tech-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 8px;
  background: #F1F5F9;
  color: #0F172A;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.3;
}

.machine-profile__tech-pill .lucide {
  color: #64748B;
}

.machine-profile__tech-empty {
  font-size: 13px;
  color: #94A3B8;
  margin-top: 4px;
  display: inline-block;
}

.machine-profile__info-note {
  margin-top: 0;
  padding: 12px;
  border-radius: 8px;
  background: rgba(241, 245, 249, 0.7);
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 12px;
  color: #64748B;
  line-height: 1.4;
}

.machine-profile__info-note .lucide {
  color: #94A3B8;
  flex-shrink: 0;
  margin-top: 1px;
}

.machine-profile__info-note p {
  margin: 0;
}

/* ——— Packages ——— */
.machine-profile__packages-title-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.machine-profile__table-wrap {
  width: 100%;
  overflow-x: auto;
  margin: 0;
}

.machine-profile__table {
  width: 100%;
  border-collapse: collapse;
  min-width: 860px;
}

.machine-profile__table th {
  text-align: start;
  padding: 12px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #94A3B8;
  border-bottom: 1px solid #F1F5F9;
  white-space: nowrap;
}

.machine-profile__table td {
  padding: 14px 12px;
  font-size: 13px;
  color: #0F172A;
  border-bottom: 1px solid #F1F5F9;
  vertical-align: middle;
}

.machine-profile__table tbody tr:hover {
  background: rgba(248, 250, 252, 0.9);
}

.machine-profile__table tbody tr:last-child td {
  border-bottom: none;
}

.machine-profile__table th.is-end,
.machine-profile__table td.is-end {
  text-align: end;
}

.machine-profile__table th.is-center,
.machine-profile__table td.is-center {
  text-align: center;
}

.machine-profile__pkg-id {
  color: #0EA5E9;
  font-weight: 600;
  font-size: 12px;
}

.machine-profile__pkg-name {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.machine-profile__pkg-desc {
  font-size: 12px;
  color: #64748B;
  line-height: 1.3;
}

.machine-profile__element-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 6px;
  background: #F1F5F9;
  color: #475569;
  font-size: 12px;
  font-weight: 500;
}

.machine-profile__element-pill .lucide {
  color: #0EA5E9;
}

.machine-profile__duration {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #0F172A;
  font-size: 12px;
}

.machine-profile__duration .lucide {
  color: #94A3B8;
}

.machine-profile__tariff {
  font-size: 13px;
  color: #0F172A;
}

.machine-profile__tariff-unit {
  margin-inline-start: 4px;
  font-size: 11px;
  font-weight: 400;
  color: #64748B;
}

.machine-profile__status {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 2px 8px;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 600;
}

.machine-profile__status.is-enabled {
  background: #F1F5F9;
  color: #0F766E;
}

.machine-profile__status.is-enabled .machine-profile__chip-dot {
  background: #14B8A6;
}

.machine-profile__status.is-disabled {
  background: #F1F5F9;
  color: #64748B;
}

.machine-profile__row-actions {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 2px;
}

.machine-profile__view-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border: none;
  background: transparent;
  color: #0EA5E9;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 6px;
}

.machine-profile__view-link:hover {
  background: #F1F5F9;
  color: #0284C7;
}

.machine-profile__more {
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #94A3B8;
  cursor: pointer;
}

.machine-profile__more:hover {
  background: #F1F5F9;
  color: #0F172A;
}

.machine-profile__packages-empty {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  padding: 20px 0 8px;
}

.machine-profile__packages-empty p {
  margin: 0;
  font-size: 13px;
  color: #64748B;
}

.machine-profile__packages-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 8px;
  padding-top: 16px;
  border-top: 1px solid #F1F5F9;
}

.machine-profile__packages-footer p {
  margin: 0;
  font-size: 11px;
  color: #94A3B8;
  max-width: 36rem;
  line-height: 1.4;
}

.machine-profile__catalog-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 600;
  color: #0EA5E9;
  text-decoration: none;
  white-space: nowrap;
}

.machine-profile__catalog-link:hover {
  color: #0284C7;
}

/* ——— Stats footer ——— */
.machine-profile__stats {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px 16px;
  padding: 14px 16px;
  background: #ffffff;
  border: none;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
}

.machine-profile__stats-left {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 14px 18px;
  min-width: 0;
}

.machine-profile__stats-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.machine-profile__stat {
  display: flex;
  align-items: center;
  gap: 10px;
}

.machine-profile__stat-icon {
  width: 28px;
  height: 28px;
  border-radius: 9999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #F1F5F9;
  flex-shrink: 0;
}

.machine-profile__stat-icon.is-teal {
  color: #14B8A6;
}

.machine-profile__stat-icon.is-sky {
  color: #0EA5E9;
}

.machine-profile__stat-icon.is-slate {
  color: #64748B;
}

.machine-profile__stat-label {
  display: block;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #94A3B8;
  line-height: 1.2;
}

.machine-profile__stat-value {
  display: block;
  margin-top: 1px;
  font-size: 14px;
  font-weight: 600;
  color: #0F172A;
  line-height: 1.25;
}

.machine-profile__stat-divider {
  width: 1px;
  height: 24px;
  background: #E2E8F0;
}

.machine-profile__gateway {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 4px 12px;
  border-radius: 8px;
  background: #F1F5F9;
  font-size: 12px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  color: #64748B;
}

.machine-profile__gateway-dot {
  width: 8px;
  height: 8px;
  border-radius: 9999px;
  background: #14B8A6;
  box-shadow: 0 0 0 3px rgba(20, 184, 166, 0.18);
}

.machine-profile__refresh {
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #94A3B8;
  cursor: pointer;
}

.machine-profile__refresh:hover {
  background: #F1F5F9;
  color: #0F172A;
}

@media (max-width: 720px) {
  .machine-profile {
    padding: 16px;
  }

  .machine-profile__inner,
  .machine-profile__inner > div {
    gap: 16px;
  }

  .machine-profile__title-row h1 {
    font-size: 22px;
  }

  .machine-profile__stat-divider {
    display: none;
  }

  .machine-profile__kv-row {
    flex-direction: column;
    gap: 12px;
  }

  .machine-profile__kv-row .is-end {
    text-align: start;
  }

  .machine-profile__card,
  .machine-profile__card--packages {
    padding: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ShowMedicalMachine/style.css"],"names":[],"mappings":"AAAA,kFAAkF;AAClF;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA,8EAA8E;AAC9E;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,WAAW;AACb;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,8BAA8B;EAC9B,SAAS;EACT,SAAS;EACT,UAAU;AACZ;;AAEA;EACE;IACE,mBAAmB;IACnB,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,4CAA4C;EAC5C,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,4EAA4E;EAC5E,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE;IACE,oDAAoD;EACtD;AACF;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6EAA6E;EAC7E,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE;;IAEE,gDAAgD;EAClD;AACF;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,6EAA6E;EAC7E,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,aAAa;EACf;AACF","sourcesContent":["/* ——— Medical machine profile (Stitch: Medical machine — Ultrasound Unit A) ——— */\n.machine-profile {\n  box-sizing: border-box;\n  width: 100%;\n  min-width: 0;\n  padding: 24px;\n  background: #ffffff;\n  min-height: 100%;\n}\n\n.machine-profile__inner {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: none;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  min-width: 0;\n}\n\n/* Loader wraps page sections in a bare div — carry the stack gap through it */\n.machine-profile__stack,\n.machine-profile__inner > div {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  min-width: 0;\n  width: 100%;\n}\n\n[dir='rtl'] .machine-profile__back .lucide,\n[dir='rtl'] .machine-profile__view-link .lucide,\n[dir='rtl'] .machine-profile__catalog-link .lucide {\n  transform: scaleX(-1);\n}\n\n/* ——— Hero ——— */\n.machine-profile__hero {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  justify-content: space-between;\n  gap: 16px;\n  margin: 0;\n  padding: 0;\n}\n\n@media (min-width: 900px) {\n  .machine-profile__hero {\n    flex-direction: row;\n    align-items: center;\n  }\n}\n\n.machine-profile__hero-left {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  min-width: 0;\n}\n\n.machine-profile__back {\n  box-sizing: border-box;\n  width: 36px;\n  height: 36px;\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #64748B;\n  cursor: pointer;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);\n  margin-top: 2px;\n}\n\n.machine-profile__back:hover {\n  background: #F1F5F9;\n  color: #0EA5E9;\n}\n\n.machine-profile__hero-text {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.machine-profile__title-row {\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.machine-profile__title-row h1 {\n  margin: 0;\n  font-size: 28px;\n  font-weight: 700;\n  letter-spacing: -0.025em;\n  line-height: 1.15;\n  color: #0F172A;\n}\n\n.machine-profile__status-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  padding-inline-start: 2px;\n}\n\n.machine-profile__chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border-radius: 9999px;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n}\n\n.machine-profile__chip--code {\n  background: #F1F5F9;\n  color: #64748B;\n  border-radius: 6px;\n  font-weight: 500;\n  font-size: 12px;\n  padding: 2px 8px;\n  align-self: center;\n}\n\n.machine-profile__chip--ok {\n  background: #ffffff;\n  color: #0F766E;\n  border: 1px solid #E2E8F0;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.machine-profile__chip--ok .machine-profile__chip-dot {\n  background: #14B8A6;\n  width: 8px;\n  height: 8px;\n}\n\n.machine-profile__chip--cal {\n  background: #F1F5F9;\n  color: #475569;\n  font-weight: 500;\n}\n\n.machine-profile__chip--cal .lucide {\n  color: #0EA5E9;\n}\n\n.machine-profile__chip--sky {\n  background: #E0F2FE;\n  color: #0284C7;\n}\n\n.machine-profile__chip--muted {\n  background: #F1F5F9;\n  color: #64748B;\n}\n\n.machine-profile__chip-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 9999px;\n  background: currentColor;\n  flex-shrink: 0;\n}\n\n.machine-profile__chip-dot.is-teal {\n  background: #14B8A6;\n}\n\n.machine-profile__hero-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n}\n\n.machine-profile__btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 14px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.machine-profile__btn--primary {\n  border: none;\n  background: #0EA5E9;\n  color: #ffffff;\n  font-weight: 600;\n}\n\n.machine-profile__btn--primary:hover {\n  background: #0284C7;\n}\n\n.machine-profile__btn--ghost {\n  border: none;\n  background: #ffffff;\n  color: #475569;\n}\n\n.machine-profile__btn--ghost:hover {\n  background: #F1F5F9;\n  color: #0F172A;\n}\n\n.machine-profile__btn--icon {\n  width: 36px;\n  padding: 0;\n  border: none;\n  background: #ffffff;\n  color: #64748B;\n}\n\n.machine-profile__btn--icon:hover {\n  background: #F1F5F9;\n  color: #0F172A;\n}\n\n/* ——— Top cards ——— */\n.machine-profile__top {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 20px;\n  min-width: 0;\n  align-items: stretch;\n}\n\n@media (min-width: 960px) {\n  .machine-profile__top {\n    grid-template-columns: minmax(0, 7fr) minmax(0, 5fr);\n  }\n}\n\n.machine-profile__card {\n  box-sizing: border-box;\n  background: #ffffff;\n  border: none;\n  border-radius: 12px;\n  padding: 20px;\n  min-width: 0;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);\n  display: flex;\n  flex-direction: column;\n}\n\n.machine-profile__card--packages {\n  padding: 24px;\n}\n\n.machine-profile__card--location {\n  justify-content: flex-start;\n}\n\n.machine-profile__clinic-list {\n  list-style: none;\n  margin: 14px 0 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.machine-profile__clinic-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 10px 12px;\n  border-radius: 8px;\n  background: #F8FAFC;\n}\n\n.machine-profile__clinic-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 6px;\n  background: #E0F2FE;\n  color: #0284C7;\n  flex-shrink: 0;\n}\n\n.machine-profile__clinic-body {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.machine-profile__clinic-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: #0F172A;\n}\n\n.machine-profile__clinic-meta {\n  font-size: 11px;\n  color: #64748B;\n}\n\n.machine-profile__empty-note {\n  margin: 14px 0 0;\n  font-size: 13px;\n  color: #94A3B8;\n}\n\n.machine-profile__card-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding-bottom: 14px;\n  margin: 0;\n  border-bottom: 1px solid #F1F5F9;\n}\n\n.machine-profile__card-head--packages {\n  align-items: center;\n  flex-wrap: wrap;\n  padding-bottom: 16px;\n  margin-bottom: 0;\n}\n\n.machine-profile__card-title {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  min-width: 0;\n}\n\n.machine-profile__card-title h2 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 700;\n  color: #0F172A;\n  line-height: 1.25;\n}\n\n.machine-profile__card-title p {\n  margin: 2px 0 0;\n  font-size: 12px;\n  color: #64748B;\n  line-height: 1.35;\n}\n\n.machine-profile__card-icon {\n  box-sizing: border-box;\n  width: 32px;\n  height: 32px;\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  background: #F1F5F9;\n  color: #0EA5E9;\n}\n\n.machine-profile__id-badge {\n  flex-shrink: 0;\n  padding: 4px 10px;\n  border-radius: 8px;\n  background: #F1F5F9;\n  font-size: 12px;\n  font-weight: 500;\n  color: #64748B;\n}\n\n.is-mono {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-variant-numeric: tabular-nums;\n}\n\n.is-strong {\n  font-weight: 600;\n  color: #0F172A;\n}\n\n.is-muted {\n  color: #64748B !important;\n}\n\n.is-soft {\n  font-weight: 400;\n  color: #94A3B8;\n  font-size: 12px;\n}\n\n.is-ok {\n  color: #14B8A6 !important;\n}\n\n.machine-profile__spec-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  column-gap: 12px;\n  row-gap: 16px;\n  margin: 0;\n  padding: 16px 0 0;\n}\n\n.machine-profile__spec-grid--supported {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n@media (min-width: 640px) {\n  .machine-profile__spec-grid,\n  .machine-profile__spec-grid--supported {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n.machine-profile__spec-grid dt {\n  margin: 0;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: #94A3B8;\n  line-height: 1.2;\n}\n\n.machine-profile__spec-grid dd {\n  margin: 2px 0 0;\n  font-size: 13px;\n  font-weight: 500;\n  color: #0F172A;\n  line-height: 1.35;\n  word-break: break-word;\n}\n\n.machine-profile__with-icon {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.machine-profile__with-icon.is-end {\n  justify-content: flex-end;\n  width: 100%;\n}\n\n.machine-profile__with-icon .lucide {\n  color: #94A3B8;\n  flex-shrink: 0;\n}\n\n.machine-profile__probe-banner {\n  margin-top: auto;\n  padding: 12px;\n  border-radius: 8px;\n  background: #F1F5F9;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  flex-wrap: wrap;\n  font-size: 12px;\n  color: #64748B;\n  line-height: 1.35;\n}\n\n.machine-profile__probe-copy {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.machine-profile__probe-copy .lucide {\n  color: #0EA5E9;\n  flex-shrink: 0;\n}\n\n.machine-profile__probe-copy strong {\n  color: #0F172A;\n  font-weight: 600;\n}\n\n.machine-profile__verified {\n  flex-shrink: 0;\n  padding: 2px 8px;\n  border-radius: 4px;\n  background: #ffffff;\n  color: #14B8A6;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);\n}\n\n/* ——— Location ——— */\n.machine-profile__location-body {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  padding: 12px 0;\n  margin: 0;\n}\n\n.machine-profile__kv-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.machine-profile__kv-row > div {\n  min-width: 0;\n  flex: 1 1 0;\n}\n\n.machine-profile__kv-row .is-end {\n  text-align: end;\n}\n\n.machine-profile__kv-label {\n  display: block;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: #94A3B8;\n  line-height: 1.2;\n}\n\n.machine-profile__kv-value {\n  margin: 2px 0 0;\n  font-size: 13px;\n  color: #0F172A;\n  line-height: 1.35;\n}\n\n.machine-profile__kv-value.is-link {\n  color: #0EA5E9;\n  font-weight: 600;\n}\n\n.machine-profile__tech-row {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 6px;\n}\n\n.machine-profile__tech-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border-radius: 8px;\n  background: #F1F5F9;\n  color: #0F172A;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.3;\n}\n\n.machine-profile__tech-pill .lucide {\n  color: #64748B;\n}\n\n.machine-profile__tech-empty {\n  font-size: 13px;\n  color: #94A3B8;\n  margin-top: 4px;\n  display: inline-block;\n}\n\n.machine-profile__info-note {\n  margin-top: 0;\n  padding: 12px;\n  border-radius: 8px;\n  background: rgba(241, 245, 249, 0.7);\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  font-size: 12px;\n  color: #64748B;\n  line-height: 1.4;\n}\n\n.machine-profile__info-note .lucide {\n  color: #94A3B8;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n.machine-profile__info-note p {\n  margin: 0;\n}\n\n/* ——— Packages ——— */\n.machine-profile__packages-title-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.machine-profile__table-wrap {\n  width: 100%;\n  overflow-x: auto;\n  margin: 0;\n}\n\n.machine-profile__table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 860px;\n}\n\n.machine-profile__table th {\n  text-align: start;\n  padding: 12px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #94A3B8;\n  border-bottom: 1px solid #F1F5F9;\n  white-space: nowrap;\n}\n\n.machine-profile__table td {\n  padding: 14px 12px;\n  font-size: 13px;\n  color: #0F172A;\n  border-bottom: 1px solid #F1F5F9;\n  vertical-align: middle;\n}\n\n.machine-profile__table tbody tr:hover {\n  background: rgba(248, 250, 252, 0.9);\n}\n\n.machine-profile__table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.machine-profile__table th.is-end,\n.machine-profile__table td.is-end {\n  text-align: end;\n}\n\n.machine-profile__table th.is-center,\n.machine-profile__table td.is-center {\n  text-align: center;\n}\n\n.machine-profile__pkg-id {\n  color: #0EA5E9;\n  font-weight: 600;\n  font-size: 12px;\n}\n\n.machine-profile__pkg-name {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.machine-profile__pkg-desc {\n  font-size: 12px;\n  color: #64748B;\n  line-height: 1.3;\n}\n\n.machine-profile__element-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border-radius: 6px;\n  background: #F1F5F9;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.machine-profile__element-pill .lucide {\n  color: #0EA5E9;\n}\n\n.machine-profile__duration {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: #0F172A;\n  font-size: 12px;\n}\n\n.machine-profile__duration .lucide {\n  color: #94A3B8;\n}\n\n.machine-profile__tariff {\n  font-size: 13px;\n  color: #0F172A;\n}\n\n.machine-profile__tariff-unit {\n  margin-inline-start: 4px;\n  font-size: 11px;\n  font-weight: 400;\n  color: #64748B;\n}\n\n.machine-profile__status {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 2px 8px;\n  border-radius: 9999px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.machine-profile__status.is-enabled {\n  background: #F1F5F9;\n  color: #0F766E;\n}\n\n.machine-profile__status.is-enabled .machine-profile__chip-dot {\n  background: #14B8A6;\n}\n\n.machine-profile__status.is-disabled {\n  background: #F1F5F9;\n  color: #64748B;\n}\n\n.machine-profile__row-actions {\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 2px;\n}\n\n.machine-profile__view-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  border: none;\n  background: transparent;\n  color: #0EA5E9;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 6px;\n}\n\n.machine-profile__view-link:hover {\n  background: #F1F5F9;\n  color: #0284C7;\n}\n\n.machine-profile__more {\n  width: 28px;\n  height: 28px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  color: #94A3B8;\n  cursor: pointer;\n}\n\n.machine-profile__more:hover {\n  background: #F1F5F9;\n  color: #0F172A;\n}\n\n.machine-profile__packages-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 20px 0 8px;\n}\n\n.machine-profile__packages-empty p {\n  margin: 0;\n  font-size: 13px;\n  color: #64748B;\n}\n\n.machine-profile__packages-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-top: 8px;\n  padding-top: 16px;\n  border-top: 1px solid #F1F5F9;\n}\n\n.machine-profile__packages-footer p {\n  margin: 0;\n  font-size: 11px;\n  color: #94A3B8;\n  max-width: 36rem;\n  line-height: 1.4;\n}\n\n.machine-profile__catalog-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #0EA5E9;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.machine-profile__catalog-link:hover {\n  color: #0284C7;\n}\n\n/* ——— Stats footer ——— */\n.machine-profile__stats {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 12px 16px;\n  padding: 14px 16px;\n  background: #ffffff;\n  border: none;\n  border-radius: 12px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);\n}\n\n.machine-profile__stats-left {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 14px 18px;\n  min-width: 0;\n}\n\n.machine-profile__stats-right {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.machine-profile__stat {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.machine-profile__stat-icon {\n  width: 28px;\n  height: 28px;\n  border-radius: 9999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #F1F5F9;\n  flex-shrink: 0;\n}\n\n.machine-profile__stat-icon.is-teal {\n  color: #14B8A6;\n}\n\n.machine-profile__stat-icon.is-sky {\n  color: #0EA5E9;\n}\n\n.machine-profile__stat-icon.is-slate {\n  color: #64748B;\n}\n\n.machine-profile__stat-label {\n  display: block;\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: #94A3B8;\n  line-height: 1.2;\n}\n\n.machine-profile__stat-value {\n  display: block;\n  margin-top: 1px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #0F172A;\n  line-height: 1.25;\n}\n\n.machine-profile__stat-divider {\n  width: 1px;\n  height: 24px;\n  background: #E2E8F0;\n}\n\n.machine-profile__gateway {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 12px;\n  border-radius: 8px;\n  background: #F1F5F9;\n  font-size: 12px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  color: #64748B;\n}\n\n.machine-profile__gateway-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 9999px;\n  background: #14B8A6;\n  box-shadow: 0 0 0 3px rgba(20, 184, 166, 0.18);\n}\n\n.machine-profile__refresh {\n  width: 28px;\n  height: 28px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  color: #94A3B8;\n  cursor: pointer;\n}\n\n.machine-profile__refresh:hover {\n  background: #F1F5F9;\n  color: #0F172A;\n}\n\n@media (max-width: 720px) {\n  .machine-profile {\n    padding: 16px;\n  }\n\n  .machine-profile__inner,\n  .machine-profile__inner > div {\n    gap: 16px;\n  }\n\n  .machine-profile__title-row h1 {\n    font-size: 22px;\n  }\n\n  .machine-profile__stat-divider {\n    display: none;\n  }\n\n  .machine-profile__kv-row {\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .machine-profile__kv-row .is-end {\n    text-align: start;\n  }\n\n  .machine-profile__card,\n  .machine-profile__card--packages {\n    padding: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
